var lib_core = require("lib-core");
var editor_3d = require("editor-3d-light");

if(typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");

var ProcessMessageController = require("ui-extensions").ProcessMessageController;

var PackageGeneratorModel = require("./packageGeneratorModel.js");
var PackageGeneratorStateMachine = require("./packageGeneratorStateMachine.js");
var PackageGeneratorView = require("./packageGeneratorView.js");
var PackageViewerController = require("../footprint3dViewer/packageFootprintViewerController.js");
var PackageMasterController = require("../packageMasterView/packageMasterController.js");
var UserSettingsController = require("../../../shared/extensions/userSettings/userSettingsController.js");
var ModelUploadController = require("../modelUploader/modelUploadController.js");
var PackageGenerationManagerController = require("../packageGenerationManager/packageGenerationManagerController.js");

var PackageGeneratorController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
    
    //EVENTS copied from inspector to use in view
    //TODO: find better way to access this?
    lib_core.GuiEvents.addEvents({
        TOGGLE_PACKAGE_SIDEBAR: {id: 'ui_package_generator_01', name: "TOGGLE_PACKAGE_SIDEBAR"},
        GENERATOR_SELECTED: {id: 'ui_package_generator_02', name: "GENERATOR_SELECTED"},
        GENERATE_PACKAGE: {id: 'ui_package_generator_03', name: "GENERATE_PACKAGE"},
        FINISH_PACKAGE: {id: 'ui_package_generator_04', name: "FINISH_PACKAGE"},
        HIDE_WARNING_POPUP_PACKAGE_OVERWRITING: {id: 'ui_package_generator_05', name: "HIDE_WARNING_POPUP_PACKAGE_OVERWRITING"},
        HIDE_WARNING_POPUP_FINISH_GENERATION: {id: 'ui_package_generator_06', name: "HIDE_WARNING_POPUP_FINISH_GENERATION"},
        HIDE_WARNING_POPUP_UNFINISHED_UPDATE_PREVIEW: {id: 'ui_package_generator_07', name: "HIDE_WARNING_POPUP_UNFINISHED_UPDATE_PREVIEW"},
        OVERWRITE_PACKAGE: {id: 'ui_package_generator_08', name: "OVERWRITE_PACKAGE"},
        GENERATOR_BACK_BUTTON_PRESSED: {id: 'ui_package_generator_09', name: "GENERATOR_BACK_BUTTON_PRESSED"},
        FINISH_PACKAGE_VERSION_CREATION: {id: 'ui_package_generator_10', name: "FINISH_PACKAGE_VERSION_CREATION"},
        OVERRIDE_PACKAGE_SETTINGS: {id: 'ui_package_generator_11', name: "OVERRIDE_PACKAGE_SETTINGS"},
        VIEW_IPC_PARAMS_READ_ONLY: {id: 'ui_package_generator_12', name: "VIEW_IPC_PARAMS_READ_ONLY"},
        
        START_FORK_PACKAGE_FROM_IPC_PARAMS: {id: 'ui_package_generator_13', name: "START_FORK_PACKAGE_FROM_IPC_PARAMS"},
        HUB_SELECTED_AND_START_FORK_PACKAGE_FROM_IPC_PARAMS: {id: 'ui_package_generator_14', name: "HUB_SELECTED_AND_START_FORK_PACKAGE_FROM_IPC_PARAMS"},
        START_FORK_PUBLIC_PACKAGE:  {id: 'ui_package_generator_15', name: "START_FORK_PUBLIC_PACKAGE"},
        HUB_SELECTED_AND_START_FORK_PUBLIC_PACKAGE: {id: 'ui_package_generator_16', name: "HUB_SELECTED_AND_START_FORK_PUBLIC_PACKAGE"},

        HIDE_WARNING_POPUP_OPEN_FORKED_PACKAGE: {id: 'ui_package_generator_18', name: "HIDE_WARNING_POPUP_OPEN_FORKED_PACKAGE"},
        PACKAGE_SEARCH_BUTTON_CLICKED: {id: 'ui_package_generator_19', name: "PACKAGE_SEARCH_BUTTON_CLICKED"},
        PACKAGE_SEARCH_CLOSE_BUTTON_CLICKED: {id: 'ui_package_generator_20', name: "PACKAGE_SEARCH_CLOSE_BUTTON_CLICKED"},
        PACKAGE_SEARCH_BOX_TEXT_ENTERED: {id: 'ui_package_generator_21', name: "PACKAGE_SEARCH_BOX_TEXT_ENTERED"},

        INSPECTOR_FOCUS: {id: 'abs_18', name: "INSPECTOR_FOCUS" },
        INSPECTOR_BLUR : {id: 'abs_18b', name: "INSPECTOR_BLUR" },
        INSPECTOR_ENTER: {id: 'abs_18c', name: "INSPECTOR_ENTER"},
        CHANGE_PROPERTY: {id: 'abs_19', name: "CHANGE_PROPERTY" }
    });

    this.events = {
        changeProperty : lib_core.GuiEvents.CHANGE_PROPERTY,
        focus: lib_core.GuiEvents.INSPECTOR_FOCUS,
        enter: lib_core.GuiEvents.INSPECTOR_ENTER,
        blur: lib_core.GuiEvents.INSPECTOR_BLUR
    };
};

lib_core.inherit(PackageGeneratorController, lib_core.Controller);
module.exports = PackageGeneratorController;

PackageGeneratorController.inject = {
    editorController: editor_3d.Editor3dController,
    cameraController: editor_3d.Camera3dController,
    switcherController: ui_extensions.SwitcherController,
    tabController: ui_extensions.TabController,
    sidebarController: ui_extensions.SidebarController,
    masterController: PackageMasterController,
    packgeViewerController: PackageViewerController,
    processMessageController: ProcessMessageController,
    userSettingsController: UserSettingsController,
    modelUploadController: ModelUploadController,
    packageGenerationManager: PackageGenerationManagerController
};

// find manager upstream and register ourselves, so that the manager can call our version-related
// functions even when our state machine is not active
PackageGeneratorController.prototype.beforeLoad = function () {
    lib_core.Controller.prototype.beforeLoad.call(this);
    this.packageGenerationManager.registerGenerator(this);
};

PackageGeneratorController.prototype.createModel = function () {
    var versionController = this.getVersionController();
    var versionModel = versionController && versionController.getModel();

    return new PackageGeneratorModel(
        this.root.data, 
        this.root.dataLoader, 
        this.switcherController && this.switcherController.getModel(),
        this.packgeViewerController && this.packgeViewerController.getModel(), 
        this.processMessageController.getModel(),
        this.masterController.getModel(), 
        this.userSettingsController.getModel(),
        versionModel, 
        this.editorController && this.editorController.getView(), 
        this.configuration
    );
};

PackageGeneratorController.prototype.createStateMachine = function () {
    var versionController = this.getVersionController();
    var versionSM = versionController && versionController.getStatemachine();

    return new PackageGeneratorStateMachine(this.root, this.getModel(), this.modelUploadController && this.modelUploadController.getStatemachine(), versionSM, this.events, this.configuration);
};

PackageGeneratorController.prototype.createView = function() {
	return new PackageGeneratorView(
        this.tabController.getView(), 
        this.masterController.getView(), 
        this.editorController && this.editorController.getView(),
        this.getModel(),
        this.getStatemachine(), 
        this.events, 
        this.configuration
    );
};

PackageGeneratorController.prototype.getVersionController = function() {
    //TODO: is this really the best way to get the versions model?  
    // -- We need a version manager the same way we have a package generation manager, that picks up the events 
    // and actually does the version creation.  Then this violation will not be necessary.
    return this.sidebarController && this.sidebarController.children.get('versions'); 
};